/* eslint-disable no-else-return */
import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from 'theme/withStyles';
import { Collapse } from 'react-collapse';
import classnames from 'classnames';
import RawHtml from 'common/RawHtml';
import PlusMinus from 'common/PlusMinus';

import buttonLinkStyles from 'styles/buttonLink';
import AtomicFi from 'fields/AtomicFi';
import commonStyles from './styles';

const styles = (theme) => {
  const common = commonStyles(theme);
  return {
    ...common,
    buttonLink: {
      ...buttonLinkStyles(theme),
      '& svg': {
        fill: '#fff',
      },
      color: theme.palette.background,
    },
    hidden: {
      display: 'none',
    },
    panelBody: {
      ...common.panelBody,
      paddingRight: 20,
    },
    panelBodyAdditional: {
      '& ul li': {
        paddingBottom: 0,
      },
    },
    panelTitle: {
      '& h1': {
        ...theme.typography.h2,
        color: theme.oaoButtons.primary.color,
        display: 'inline-box',
        marginBottom: 0,
      },
      '&:hover h1': {
        color: theme.palette.background,
        textDecoration: 'underline',
      },
      padding: [theme.spacing.unit * 2, theme.spacing.xs + theme.spacing.unit],
    },
    root: {
      '& .panel-heading': {
        backgroundColor: theme.tabs.color,
        textAlign: 'left',
      },
      paddingLeft: 0,
      paddingRight: 0,
    },
    servicesList: {
      width: '100%',
    },
  };
};

export const HomeServicesPanel = ({ classes, resources, theme }) => {
  const { data, fields } = useSelector((props) => props);

  const [isOpen, setIsOpen] = useState(true);

  const { servicesTitle } = resources;
  const headerText = <RawHtml type="span">{servicesTitle}</RawHtml>;

  const panelBody = useMemo(() => {
    if (data === null || data === undefined) {
      return null;
    }
    if (data instanceof Object && Object.keys(data).length === 0) {
      return <p>This application currently has no services.</p>;
    }

    return (
      <ul>
        {Object.keys(data)?.map(
          (key) =>
            key === 'appRequest_atomicfi_directDeposit' && (
              <li
                key={key}
                className={classes.panelItem}
                data-name={fields[key]?.label}
                data-id={key}
              >
                <div className={classnames('', classes.servicesList)}>
                  <AtomicFi name={key} key={key} {...fields[key]} />
                </div>
              </li>
            ),
        )}
      </ul>
    );
  }, [classes.panelItem, data, fields]);

  return fields.appRequest_atomicfi_directDeposit ? (
    <div
      className={classnames('panel panel-primary loading panel-services', classes.root)}
      role="tab"
    >
      <div className="panel-heading" id="collapseHeading-services">
        <div
          role="button"
          tabIndex="0"
          aria-expanded={isOpen}
          aria-controls="collapseAreaID-services"
          className={classnames('panel-title', classes.panelTitle)}
          onClick={() => setIsOpen(!isOpen)}
        >
          <div
            data-toggle="collapse"
            href="#collapseHeading-services"
            className={classnames('buttonLink get-services', classes.buttonLink, {
              collapsed: !isOpen,
              [classes.collapsed]: !isOpen,
            })}
          >
            <PlusMinus collapsed={!isOpen} /> <h1>{headerText}</h1>
          </div>
        </div>
      </div>
      <Collapse isOpened={isOpen}>
        <div id="collapseAreaID-services" className="panel-collapse">
          <div
            className={classnames('panel-body', classes.panelBody, classes.panelBodyAdditional, {
              [classes.hidden]: !isOpen,
            })}
          >
            {panelBody}
          </div>
        </div>
      </Collapse>
    </div>
  ) : null;
};

HomeServicesPanel.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  openDialog: PropTypes.func.isRequired,
  resources: PropTypes.shape({
    directDepositCompleteLabel: PropTypes.string,
    directDepositLabel: PropTypes.string,
    servicesTitle: PropTypes.string,
  }).isRequired,
  theme: PropTypes.shape({
    palette: PropTypes.shape({
      primary: PropTypes.string,
      secondary: PropTypes.string,
    }),
  }).isRequired,
};

const HomeServicesPanelStyled = withStyles(styles)(HomeServicesPanel);

export default HomeServicesPanelStyled;
